import type {
  AdminSettingCompanySetting,
  CompanySetting
} from '~/models/CompanySetting';
import { deleteRequest, putRequest } from '~/utils/api/api_handler';
import type { NskResponse } from '~/models/Api';

const paths = {
  update: '/admin/company_settings/:id',
  destroy: '/admin/company_settings/:id',
  updateCompanyInformation: '/admin/company_settings/update_company_information'
};

export const update = async (
  companySetting: CompanySetting
): Promise<NskResponse<void>> =>
  putRequest(
    paths.update.replace(':id', String(companySetting.companyMasterId)),
    { companySetting }
  );

export const destroy = async (
  companySetting: CompanySetting
): Promise<NskResponse<void>> =>
  deleteRequest(
    paths.destroy.replace(':id', String(companySetting.companyMasterId))
  );

export const updateCompanyInformation = async (
  companySetting: AdminSettingCompanySetting
): Promise<NskResponse> =>
  putRequest(paths.updateCompanyInformation, { companySetting });
